import { render, staticRenderFns } from "./SearchProductPopup.vue?vue&type=template&id=2dbe3810&scoped=true"
import script from "./SearchProductPopup.vue?vue&type=script&lang=js"
export * from "./SearchProductPopup.vue?vue&type=script&lang=js"
import style0 from "./SearchProductPopup.vue?vue&type=style&index=0&id=2dbe3810&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe3810",
  null
  
)

export default component.exports